import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Popover,
  CardHeader,
  CardActions,
  Divider,
  Button,
  TextField
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 231,
    maxWidth: '100%'
  },
  email: {
    padding: theme.spacing(1, 2)
  },
  actions: {
    justifyContent: 'center',
    padding: 0
  },
  button: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    padding: theme.spacing(2)
  }
}));

const NotificationsPopover = props => {
  const { anchorEl, onSubmit, ...rest } = props;

  const classes = useStyles();

  const [email, setEmail] = useState('');

  const handleClose = () => {
    rest.onClose();
    setEmail('');
  }

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <div className={classes.root}>
        <CardHeader title="Add new member" />
        <Divider />
        <div className={classes.email}>
          <TextField
            autoFocus
            fullWidth
            label="Email"
            margin="dense"
            name="email"
            onChange={({ target }) => setEmail(target.value)}
            type="email"
            value={email || ''}
            variant="outlined"
          />
        </div>
        <Divider />
        <CardActions className={classes.actions}>
          <Button
            className={classes.button}
            disabled={!email.length}
            fullWidth
            onClick={() => onSubmit({ email }, handleClose)}
            size="small"
          >
            Add
          </Button>
        </CardActions>
      </div>
    </Popover>
  );
};

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default NotificationsPopover;
